// cleanup_convert_to_typescript_file_GENERICS_TRANSFERS

import { createUseStyles } from '@glu/theming';

const styles = ({
  palette: { background, error, secondary, text },
  spacing: { unit },
  typography
}) => ({
  root: {
    '& .modal .dialog': {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    },
    '& section': {
      margin: 'auto'
    },
    '& .modal .modal-body': {
      display: 'flex',
      background,
      borderLeft: `4px solid ${error.lightOrange}`
    }
  },
  modal: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    paddingBottom: unit * 2
  },
  modalDialog: {
    '& [class^="header"]': {
      '& [class^="icon-exclamation-triangle"]': {
        display: 'none'
      }
    },
    '& [class^="actions"]': {
      textAlign: 'center',
      margin: 0
    }
  },

  icon: {
    padding: [2.75 * unit, 0],
    '& svg': {
      fill: secondary.normal,
      width: unit * 6,
      height: unit * 6
    }
  },
  message: {
    color: text.dark,
    fontSize: unit * 2,
    textAlign: 'center',
    padding: [2 * unit, 0]
  },
  submit: {
    borderRadius: unit * 0.75,
    textTransform: 'uppercase',
    marginRight: unit * 4
  },
  close: {
    cursor: 'pointer',
    position: 'absolute',
    right: unit * 3,
    top: unit * 3,
    '& .icon-x-circle-next': {
      fill: text.dark
    }
  },
  warningTitle: {
    fontSize: unit * 2.5,
    fontWeight: typography.fontWeightRegular,
    textTransform: 'uppercase'
  }
});

export default createUseStyles(styles);
